import styled from "@emotion/styled";

export const StyledSummaries = styled.div`
  padding: 0px 5px;

  .summaries-date {
    font-size: 18px;
    font-weight: 500;
    color: var(--primary);
  }

  .summaries-list {
    display: flex;
    flex-direction: column;
    gap: 0;
    padding: 0px 20px;

    --color-text-primary: #1e0f3d;
    --color-text-secondary: #7b6a99;
    --color-background-primary: #ffffff;
    --color-background-secondary: #f5f0ff;
    --color-border-tertiary: #e4d9f7;

    .sentiment-badge {
      font-size: 11px;
      padding: 3px 8px;
      border-radius: 5px;
      font-weight: 500;
      text-transform: capitalize;
    }
    .s-positive {
      background: #eaf3de;
      color: #3b6d11;
    }
    .s-neutral {
      background: #f1efe8;
      color: #5f5e5a;
    }
    .s-concerned {
      background: #faeeda;
      color: #854f0b;
    }
    .s-negative {
      background: #fcebeb;
      color: #a32d2d;
    }
    .card-body {
      padding: 0 14px 14px;
      border-top: 0.5px solid var(--color-border-tertiary);
    }
    .card-body.open {
      display: block;
    }
    .section {
      margin-top: 12px;
    }
    .label {
      font-size: 11px;
      font-weight: 500;
      color: var(--color-text-secondary);
      text-transform: uppercase;
      letter-spacing: 0.06em;
      margin-bottom: 6px;
    }
    .short-summary {
      font-size: 13px;
      color: var(--color-text-primary);
      line-height: 1.6;
      padding: 10px 12px;
      background: var(--color-background-secondary);
      border-radius: 8px;
      border-left: 3px solid #7f77dd;
    }
    .chips {
      display: flex;
      flex-wrap: wrap;
      gap: 5px;
    }
    .chip {
      font-size: 11px;
      padding: 3px 8px;
      border-radius: 20px;
      background: var(--color-background-secondary);
      border: 0.5px solid var(--color-border-tertiary);
      color: var(--color-text-secondary);
    }
    .action-item {
      display: flex;
      align-items: flex-start;
      gap: 8px;
      padding: 8px 10px;
      background: var(--color-background-secondary);
      border-radius: 8px;
      margin-bottom: 5px;
    }
    .priority-dot {
      width: 7px;
      height: 7px;
      border-radius: 50%;
      flex-shrink: 0;
      margin-top: 4px;
    }
    .high {
      background: #e24b4a;
    }
    .medium {
      background: #ef9f27;
    }
    .low {
      background: #639922;
    }
    .action-who {
      font-size: 11px;
      color: var(--color-text-secondary);
    }
    .action-what {
      font-size: 13px;
      color: var(--color-text-primary);
    }
    .action-due {
      font-size: 11px;
      color: #185fa5;
      margin-top: 2px;
    }
    .two-col {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
    }
    .concern-item {
      font-size: 12px;
      color: var(--color-text-primary);
      padding: 3px 0;
      border-bottom: 0.5px solid var(--color-border-tertiary);
      line-height: 1.5;
    }
    .concern-item:last-child {
      border-bottom: none;
    }
    .dot-positive {
      background: #639922;
    }
    .dot-neutral {
      background: #888780;
    }
    .dot-concerned {
      background: #ef9f27;
    }
    .dot-negative {
      background: #e24b4a;
    }
  }
`;
